import React, { useState } from 'react';
import {
    FileField,
    FileInput,
    ListButton,
    SaveButton,
    SimpleForm,
    Toolbar as RaToolbar,
    useCreate,
    useNotify,
    useRedirect,
} from 'react-admin';
import { fileParser } from '@src/fileParser';
import { dataObject } from '@src/object.type';

interface IFileUpload {
    headers: string[];
    fileInputLabel: string;
    api: string;
    resource: string;
    verifyData: (data: dataObject[]) => dataObject[] | Promise<dataObject[]>;
}

export const FileUpload: React.FC<IFileUpload> = ({
    headers,
    fileInputLabel,
    api,
    resource,
    verifyData,
}) => {
    const [disabled, setDisabled] = useState(true);
    const [csvData, setCsvData] = useState<dataObject[]>();
    const [create] = useCreate();
    const redirect = useRedirect();
    const notify = useNotify();

    const handleFileChange = async (file: File) => {
        if (file) {
            const { data, errors } = await fileParser(file, headers);
            try {
                if (errors.length === 0) {
                    setCsvData(data);
                    setDisabled(false);
                } else {
                    notify(
                        errors[0].message
                            ? errors[0].message
                            : 'app.action.fileUpload.error',
                        { type: 'error' }
                    );
                }
            } catch (error) {
                notify('app.action.fileUpload.error', { type: 'error' });
            }
        }
    };

    const onSave = async () => {
        const validData = csvData ? await verifyData(csvData) : [];
        setDisabled(true);
        if (validData) {
            create(
                api,
                { data: validData },
                {
                    onSuccess: () => {
                        redirect('list', resource);
                        notify('app.action.fileUpload.success', {
                            type: 'info',
                        });
                    },
                }
            );
        }
    };

    const Toolbar = () => (
        <RaToolbar>
            <SaveButton disabled={disabled} variant="text" size="medium" />
            <ListButton resource={resource} variant="text" size="medium" />
        </RaToolbar>
    );

    return (
        <SimpleForm toolbar={<Toolbar />} onSubmit={onSave}>
            <FileInput
                accept={{
                    'application/csv': ['.csv'],
                    'application/vnd.ms-excel': ['.xls'],
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        ['.xlsx'],
                }}
                source="attachments"
                label={fileInputLabel}
                onChange={handleFileChange}
            >
                <FileField source="src" title="title" />
            </FileInput>
        </SimpleForm>
    );
};
